import Fn from "./Fn";
import SectionOne from './Modules/Section/One'
import SectionTwo from "./Modules/Section/Two"
import SectionThree from "./Modules/Section/Three"
import SectionFour from "./Modules/Section/Four"
import SectionSix from "./Modules/Section/Six"
import SectionFive from "./Modules/Section/Five"

class App {
  constructor () {
    window.isSamsungBrowser= ~navigator.userAgent.indexOf('SamsungBrowser')
    
    window.breakPoints = {
      pc: 1156,
      tablet: 768,
      mobile: 0
    };
    window.randomString = Fn.randomString()
    
    this.init();
  }
  
  init () {
    //  统一渲染背景图片
    this._renderBg();
    this._sections()
    
    this._headroom()
    this._shareAndReturnTop()
    //  处理移动端页脚的分享
    this._mobileFooterShareBoxHandler()
  }
  
  _mobileFooterShareBoxHandler () {
    $('.appFooter .right').append($('#shareLists').html())
  }
  
  _headroom () {
    let body = document.body
    let one = $('#sectionOne')
    $(window).scroll(() => {
      let scrollTop = $(window).scrollTop()
      let height = one.outerHeight()
      
      if (scrollTop > height) {
        body.classList.add('showFixed')
      } else {
        body.classList.remove('showFixed')
      }
    })
    
    let myElement = document.querySelector("#headroomFooter")
    let headroom = new Headroom(myElement)
    headroom.init()
  }
  
  _shareAndReturnTop () {
    $('.shareBox').html($('#shareLists').html())
    
    $('.returnTop').on('click', () => $(document.body).velocity('scroll'))
  }
  
  _sections () {
    new SectionOne()
    window.onload = () => {
      new SectionTwo()
      new SectionThree()
      new SectionFour()
      new SectionFive()
      new SectionSix()
      
      //  执行动画
      const oSR = window.ScrollReveal({
        reset: false,
        origin: 'bottom',
        duration: 1000,
        delay: 0,
        scale: 1,
        easing: 'ease-in-out',
        mobile: false,
        distance: '40px',
      })
      
      oSR.reveal('.animate1', {delay: 0})
      oSR.reveal('.animate2', {delay: 200})
      oSR.reveal('.animate3', {delay: 400})
      
      //  加载page.js
      if (window.a2a === undefined) {
        $.getScript('https://static.addtoany.com/menu/page.js')
      }
    }
  }
  
  /**
   * 渲染页面中存在的背景图片
   */
  _renderBg () {
    $("[data-bg]").map((k, el) => {
      let images = JSON.parse(el.dataset.bg);
      let randomString = Fn.randomString();
      let innerWidth = window.innerWidth;
      let bgImg = "";
      
      //  check breakpoints
      if (innerWidth >= window.breakPoints.pc) {
        bgImg = images.pc;
      } else if (innerWidth >= window.breakPoints.tablet) {
        bgImg = images.tab;
      } else {
        bgImg = images.mb;
      }
      
      //  set class
      el.classList.add(randomString);
      //  render img
      Fn.renderImgTag(bgImg).then(img => {
        this.__setCoverBgStyle(images, randomString);
        el.classList.add("coverBgLoaded");
      });
    });
  }
  
  /**
   * set cover bg style
   * @param oBg
   * @param randomString
   * @private
   */
  __setCoverBgStyle (oBg, randomString) {
    Fn.writeStyle(
      `${randomString}Style`,
      `
     @media(min-width: ${
        window.breakPoints.mobile
        }px){.${randomString}::after{background-image: url('${oBg.mb}?random=${window.randomString}')}}
     @media(min-width: ${
        window.breakPoints.tablet
        }px){.${randomString}::after{background-image: url('${oBg.tab}?random=${window.randomString}')}}
     @media(min-width: ${
        window.breakPoints.pc
        }px){.${randomString}::after{background-image: url('${oBg.pc}?random=${window.randomString}')}}
    `
    );
  }
}

new App();
